export default function InfiniteLoader() {
  return (
    <div className="loading-icon">
      <div className="loading-icon-box">
        <span></span>
      </div>
    </div>
  );
}
